import { httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import {
    getOutputConfigOutputRecords,
    setDefaultConfigOutputRecords,
    setConfigOutputRecordError,
    setConfigOutputRecordColSearchStr,
    sortConfigOutputRecordItems,
    setConfigOutputRecordPageSize
} from "../../../../constants/model-reducers/external/recharge/output-configuration/output-configuration-output-records.settings";
import { convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    isConfigOutputRecordLoaded: false,
    isConfigOutputRecordError: false,
    configOutputRecordItems: DEFAULT_TABLE_RESULT_MODEL,
    configOutputRecordColSort: '',
    configOutputRecordIsSortedAsc: false,
});

const initialState = defaultState();

export const configOutputRecordActions = {
    setDefaultConfigOutputRecords: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultConfigOutputRecords,
            configOutputRecordItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getOutputConfigOutputRecords: (outputConfigurationId, pageIndex) => async (dispatch, state) => {
        const { Headers, Pagination } = state().configOutputRecords.configOutputRecordItems;
        const { configOutputRecordIsSortedAsc, configOutputRecordColSort } = state().configOutputRecords;

        const userId = sessionStorage.getItem('UserID');

        try {
            const data = {
                PageFilter: {
                    PageIndex: pageIndex ?? 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: configOutputRecordColSort,
                IsSortAscending: configOutputRecordIsSortedAsc,
            };

            let configOutputRecordItems = await httpPost('external/recharge/getConfigurationOutputRecords/' + outputConfigurationId, data);

            dispatch({
                type: getOutputConfigOutputRecords,
                configOutputRecordItems: Object.keys(configOutputRecordItems).length > 0
                    ? configOutputRecordItems
                    : DEFAULT_TABLE_RESULT_MODEL,
                isConfigOutputRecordLoaded: true,
                isConfigOutputRecordError: false
            });

        } catch (e) {
            dispatch({
                type: setConfigOutputRecordError,
                isConfigOutputRecordError: true,
                isConfigOutputRecordLoaded: false
            });
        }
    },
    setConfigOutputRecordColSearchStr: (event, key) => async (dispatch, state) => {
        const val = event.target.value;
        const { configOutputRecordItems } = state().configOutputRecords;

        const updatedHeaders = {
            ...configOutputRecordItems.Headers,
            [key]: {
                ...configOutputRecordItems.Headers[key],
                searchString: val
            }
        };

        const configOutputRecordItemsUpd = {
            ...configOutputRecordItems,
            Headers: updatedHeaders
        };

        dispatch({
            type: setConfigOutputRecordColSearchStr,
            data: configOutputRecordItemsUpd,
            isConfigOutputRecordError: false,
            isConfigOutputRecordLoaded: true
        });
    },
    resizeConfigOutputRecordPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setConfigOutputRecordPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    sortConfigOutputRecordItems: (columnClicked, isSortedAsc, outputConfigurationId) => async (dispatch, state) => {
        const { PageNumber, PageSizes, PerPage } = state().configOutputRecords.configOutputRecordItems.Pagination;
        const { configOutputRecordItems } = state().configOutputRecords;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...configOutputRecordItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc
        };

        var resConfigOutputRecordItems = await httpPost('external/recharge/getConfigurationOutputRecords/' + outputConfigurationId, data);

        if (resConfigOutputRecordItems.ok === false) {
            dispatch({
                type: setConfigOutputRecordError,
                isRechargingInventoryError: true,
                isRechargingInventoryLoaded: false
            });
        } else {
            dispatch({
                type: sortConfigOutputRecordItems,
                configOutputRecordItems: Object.keys(resConfigOutputRecordItems).length > 0 ? resConfigOutputRecordItems : DEFAULT_TABLE_RESULT_MODEL,
                configOutputRecordColSort: columnClicked,
                configOutputRecordIsSortedAsc: isSortedAsc,
                isConfigOutputRecordLoaded: true
            });
        }
    },
    extractConfigOutputRecords: (outputConfigurationId) => async (dispatch, state) => {
        const { Headers } = state().configOutputRecords.configOutputRecordItems;
        const { configOutputRecordIsSortedAsc, configOutputRecordColSort } = state().configOutputRecords;

        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');

        var filename = `ATEM ${dealName} Output Records Extract – ${formattedTimeZoneDate}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: configOutputRecordColSort,
            IsSortAscending: configOutputRecordIsSortedAsc,
            FileName: filename
        };

        httpDownload('external/recharge/getConfigurationOutputRecordsExtract/' + outputConfigurationId, data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getOutputConfigOutputRecords:
            return {
                ...state,
                configOutputRecordItems: action.configOutputRecordItems,
                isConfigOutputRecordLoaded: action.isConfigOutputRecordLoaded,
                isConfigOutputRecordError: action.isConfigOutputRecordError
            };
         case setConfigOutputRecordError:
            return {
                ...state,
                isConfigOutputRecordLoaded: action.isConfigOutputRecordLoaded,
                isConfigOutputRecordError: action.isConfigOutputRecordError
            }
        case setConfigOutputRecordColSearchStr:
            return {
                ...state,
                configOutputRecordItems: action.data,
                isConfigOutputRecordLoaded: action.isConfigOutputRecordLoaded,
                isConfigOutputRecordError: action.isConfigOutputRecordError
            }
        case sortConfigOutputRecordItems:
            return {
                ...state,
                configOutputRecordItems: action.configOutputRecordItems,
                configOutputRecordColSort: action.configOutputRecordColSort,
                configOutputRecordIsSortedAsc: action.configOutputRecordIsSortedAsc,
                isConfigOutputRecordLoaded: action.isConfigOutputRecordLoaded,
            }
        case setConfigOutputRecordPageSize:
            return {
                ...state,
                configOutputRecordItems: {
                    ...state.configOutputRecordItems,
                    Pagination: {
                        ...state.configOutputRecordItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setDefaultConfigOutputRecords:
            return initialState;
        default:
            return state;
    }
};